import { useIntl } from 'react-intl';

import Picture from 'components/picture';
import { parseStringifiedJSON } from 'utils/parse-string';

import {
  Badge,
  BadgeContainer,
  ItemThumbnailContainer,
  ThumbnailBehind,
  ThumbnailBox,
} from './styled';

interface IItemThumbnailWithBadge {
  totalItems: number;
  image: string | null | undefined;
  name: string | null | undefined;
}

export const ItemThumbnailWithBadge = ({ totalItems, image, name }: IItemThumbnailWithBadge) => {
  const { formatMessage } = useIntl();
  const accessibilityLabelTotalItems = formatMessage(
    { id: 'totalItemsInTheOrder' },
    { amount: totalItems }
  );

  return (
    <ItemThumbnailContainer accessible accessibilityLabel={accessibilityLabelTotalItems}>
      {Array.from({ length: 2 }).map((_, index) => (
        <ThumbnailBehind
          key={index}
          style={{
            transform: [{ rotate: index % 2 === 0 ? '12deg' : '-12deg' }],
          }}
        />
      ))}
      <ThumbnailBox>
        <BadgeContainer>
          <Badge variant="number-solid">{totalItems.toString()}</Badge>
        </BadgeContainer>
        {image && (
          <Picture
            image={parseStringifiedJSON({ value: image || '{}' })}
            accessibilityHidden
            width="$13.5"
            height="$13.5"
            alt={name || ''}
          />
        )}
      </ThumbnailBox>
    </ItemThumbnailContainer>
  );
};
